// extracted by mini-css-extract-plugin
export default {"drinkBody":"Drink_drinkBody__ApXl+","drinksCart":"Drink_drinksCart__-HQ5p","drinkItem":"Drink_drinkItem__38Ut8","priceBtn":"Drink_priceBtn__gNjs7"};